import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-status',
    templateUrl: './status.component.html',
    standalone: false
})
export class InstallationStatusPluginComponent extends BasePlugin {
  public statuses: any;
  public config: any;
  public editRoute = ['installation', 'status', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.statuses = this.config.Statuses;
  }
}
PluginComponent.plugins['installationstatus'] = InstallationStatusPluginComponent;
